import { Create, useForm } from '@refinedev/antd'
import { useNavigate } from 'react-router-dom'
import {
  Form,
  Input,
  Select,
  Checkbox,
  Card,
  Row,
  Col,
  DatePicker,
} from 'antd'
import dayjs from 'dayjs'

interface CreatePatientForm {
  email: string
  password?: string
  firstName?: string
  lastName?: string
  phone?: string
  dateOfBirth?: string
  gender?: 'MALE' | 'FEMALE' | 'OTHER'
  address?: string
  city?: string
  postalCode?: string
  marketingConsent?: boolean
  smsConsent?: boolean
}

export default function PatientCreatePage() {
  const navigate = useNavigate()

  const { formProps, saveButtonProps } = useForm<CreatePatientForm>({
    resource: 'patients',
    action: 'create',
    redirect: false,
    onMutationSuccess: (data) => {
      const response = data as unknown as { data: { id: string } }
      navigate(`/patients/${response.data.id}`)
    },
  })

  return (
    <Create
      title="Dodaj novog pacijenta"
      saveButtonProps={saveButtonProps}
    >
      <Form
        {...formProps}
        layout="vertical"
      >
        {/* Personal Information */}
        <Card title="Lični podaci" style={{ marginBottom: 16 }}>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item label="Ime" name="firstName">
                <Input placeholder="Unesite ime" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Prezime" name="lastName">
                <Input placeholder="Unesite prezime" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: 'Email je obavezan' },
                  { type: 'email', message: 'Unesite validnu email adresu' },
                ]}
              >
                <Input placeholder="email@primer.com" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Lozinka"
                name="password"
                extra="Ostavite prazno ako će pacijent koristiti Google prijavu"
              >
                <Input.Password placeholder="Opciono - ostavite prazno za Google prijavu" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Telefon" name="phone">
                <Input placeholder="+381 60 123 4567" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Datum rođenja"
                name="dateOfBirth"
                getValueProps={(value) => ({
                  value: value ? dayjs(value) : undefined,
                })}
                getValueFromEvent={(date) => date?.format('YYYY-MM-DD')}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  format="DD.MM.YYYY"
                  placeholder="Izaberite datum"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Pol" name="gender">
                <Select placeholder="Izaberite pol" allowClear>
                  <Select.Option value="MALE">Muški</Select.Option>
                  <Select.Option value="FEMALE">Ženski</Select.Option>
                  <Select.Option value="OTHER">Drugo</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Address */}
        <Card title="Adresa" style={{ marginBottom: 16 }}>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item label="Adresa" name="address">
                <Input placeholder="Ulica i broj" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Grad" name="city">
                <Input placeholder="Beograd" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Poštanski broj" name="postalCode">
                <Input placeholder="11000" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* Consents */}
        <Card title="Saglasnosti">
          <Form.Item
            name="marketingConsent"
            valuePropName="checked"
          >
            <Checkbox>
              <span style={{ fontWeight: 500 }}>Marketing saglasnost</span>
              <br />
              <span style={{ color: '#8c8c8c', fontSize: 12 }}>
                Pacijent je saglasan da prima marketinške materijale
              </span>
            </Checkbox>
          </Form.Item>
          <Form.Item
            name="smsConsent"
            valuePropName="checked"
          >
            <Checkbox>
              <span style={{ fontWeight: 500 }}>SMS obaveštenja</span>
              <br />
              <span style={{ color: '#8c8c8c', fontSize: 12 }}>
                Pacijent je saglasan da prima SMS obaveštenja
              </span>
            </Checkbox>
          </Form.Item>
        </Card>
      </Form>
    </Create>
  )
}
